export default __webpack_public_path__ + "static/media/scissors.a5123035.png";